/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Automate_Daily_WorkInputs */



/**
* | output |
* | --- |
* | "Build an agent for a task I repeat" |
*
* @param {Uno_Welcome_Suggestion_Automate_Daily_WorkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_automate_daily_work = /** @type {((inputs?: Uno_Welcome_Suggestion_Automate_Daily_WorkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Automate_Daily_WorkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einen Agenten für eine wiederkehrende Aufgabe bauen")
	return /** @type {LocalizedString} */ ("Build an agent for a task I repeat")
});